export function round2points(value: number) {
    return Math.round(value * 100) / 100;
}
